import * as React from 'react';
import { Icon, Segment } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
import { TagFilter } from '~/InfoCardsFilter/TagFilter';
export var TagsFilter = function (_a) {
    var filter = _a.filter, extraTags = _a.extraTags;
    return extraTags.length > 0 ? (<Segment data-testid='tag-filter'>
			{extraTags.map(function (tag) { return (<TagFilter condition={tag} filter={filter} key={InfoCardApi.conditionKey(tag)}>
					{tag.title}
					<Icon name='delete'/>
				</TagFilter>); })}
		</Segment>) : null;
};
